__webpack_require__.p = "https://www.powerbits.net/en/";